import {
  user_signed_in,
  user_signed_out,
  login_error_handler
} from '../actions/types';

const INITIAL_STATE = {
  loaded: false,
  signedIn: false,
  loginError: false,
  loginErrorMessage: '',
  headers: {
    idtoken: ''
  }
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case user_signed_in: {
      const headers = { ...state.headers };

      headers.idtoken = action.payload;

      return { ...state, loaded: true, signedIn: true, loginError: false, headers };
    }
    case user_signed_out: {
      const loginError = state.loginError;
      return { ...INITIAL_STATE, loaded: true, loginError };
    }
    case login_error_handler: {
      const { message, workspace } = action.payload;
      if (message === 'Invalid email') {
        return { ...INITIAL_STATE, loaded: true, loginError: true, loginErrorMessage: `An ${workspace} Google account is required to Login` };
      } else {
        return { ...INITIAL_STATE, loaded: true, loginError: true,
          loginErrorMessage: "There is an error with this workspace. Please contact Prism administration." };
      }
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.js